import _ from 'lodash'
import immutable from 'immutable'

import {SOCKET_ROOM} from './socket.room'
import {
    presenceList,
    presenceJoin,
    presenceLeave,
    presenceUpdate
} from './socket.action'



const TYPE_PRESENCE_TRACK = 'PRESENCE_TRACK'
const TYPE_PRESENCE_JOIN = 'PRESENCE_JOIN'
const TYPE_PRESENCE_LIST = 'PRESENCE_LIST'
const TYPE_PRESENCE_UPDATE = 'PRESENCE_UPDATE'
const TYPE_PRESENCE_LEAVE = 'PRESENCE_LEAVE'
const TYPE_PRESENCE_ERROR = 'PRESENCE_ERROR'


const TRACKING_KEYS = [
    'name',
    'leg',
    'subsection',
]

let presenceSocket = null

let HANDLERS = {
    [TYPE_PRESENCE_JOIN]: function(store, socket, data) {
        store.dispatch(presenceJoin(
            socket,
            data.presence
        ))
    },
    [TYPE_PRESENCE_LIST]: function(store, socket, data) {
        store.dispatch(presenceList(
            socket,
            data.presences
        ))
    },
    [TYPE_PRESENCE_UPDATE]: function(store, socket, data) {
        store.dispatch(presenceUpdate(
            socket,
            data.presence
        ))
    },
    [TYPE_PRESENCE_LEAVE]: function(store, socket, data) {
        store.dispatch(presenceLeave(
            socket,
            data.clientId
        ))
    },
    [TYPE_PRESENCE_ERROR]: function(store, socket, data) {
        console.error('Presence error:', data.message)
    }
}


let listen = (store, socket) => {
    presenceSocket = socket
    socket.on(SOCKET_ROOM.PRESENCE, function(data) {
        if (data.type in HANDLERS) {
            let handler = HANDLERS[data.type]
            handler(store, socket, data)
        }
    })
}


export default {
    listen: listen,

    update: function(state, clientId, newInfo) {
        if (!presenceSocket) {
            return state
        }

        let presenceInfo = state.getIn(['socket', 'presence', clientId])
        presenceInfo = presenceInfo ? presenceInfo.toJS() : {}

        _.extend(presenceInfo, newInfo)
        let info = _.pick(presenceInfo, TRACKING_KEYS)

        state = state.setIn(['socket', 'presence', clientId], immutable.fromJS(info))
        info.type = TYPE_PRESENCE_UPDATE
        presenceSocket.emit(SOCKET_ROOM.PRESENCE, info)

        return state
    }
}
